import { makeStyles, Theme, Typography } from "@material-ui/core";
import { VFC } from "react";
import { Colors, Shades } from "../../../style/Colors";

const useStyles = makeStyles((theme: Theme) => ({
  status: {
    color: Colors.white,
    fontWeight: "bold",
    backgroundColor: Shades.gray40,
    borderRadius: "4px",
    padding: "0px 4px 0px 4px",
  },
}));

interface IIdBoxProps {
  id: number;
}

export const IdBox: VFC<IIdBoxProps> = (props) => {
  const { id } = props;
  const classes = useStyles();

  return (
    <Typography variant="body2" className={classes.status}>
      {id}
    </Typography>
  );
};
